import Lib from '../../../commons/lib';

export default class Service {
  static naptarUrl = window.location.origin + '/api/naptar/';

  static helyszinUrl = window.location.origin + '/api/helyszin/';

  // NAPTAR START

  static listNaptartipus(aktiv, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'naptartipus/list',
      args: { requestType: 'naptartipus-list' },
      params: { aktiv }
    }], fnDone);
  }

  static addNaptartipus(naptartipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.naptarUrl + 'naptartipus',
      args: { requestType: 'naptartipus-post' },
      data: naptartipus
    }], fnDone);
  }

  static editNaptartipus(naptartipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.naptarUrl + 'naptartipus',
      args: { requestType: 'naptartipus-put' },
      data: naptartipus
    }], fnDone);
  }

  static deleteNaptartipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.naptarUrl + 'naptartipus',
      args: { requestType: 'naptartipus-delete' },
      params: {
        id: id
      }
    }], fnDone);
  }

  static listEsemenytipus(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'esemenytipus/list',
      args: { requestType: 'esemenytipus-list' },
    }], fnDone);
  }

  static addEsemenytipus(esemenytipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.naptarUrl + 'esemenytipus',
      args: { requestType: 'esemenytipus-post' },
      data: esemenytipus
    }], fnDone);
  }

  static editEsemenytipus(esemenytipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.naptarUrl + 'esemenytipus',
      args: { requestType: 'esemenytipus-put' },
      data: esemenytipus
    }], fnDone);
  }

  static deleteEsemenytipus(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.naptarUrl + 'esemenytipus',
      args: { requestType: 'esemenytipus-delete' },
      params: {
        id: id
      }
    }], fnDone);
  }

  static listNaptarNezet(kezdet, naptartipusid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'naptar/listnezet',
      args: { requestType: 'naptar-listnezet-get' },
      params: {
        kezdet, naptartipusid
      }
    }], fnDone);
  }

  static addNaptar(naptar, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.naptarUrl + 'naptar',
      args: { requestType: 'naptar-post' },
      data: naptar
    }], fnDone);
  }

  static copyDay(obj, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.naptarUrl + 'naptar/masolas',
      args: { requestType: 'naptar-masolas-post' },
      data: obj,
    }], fnDone);
  }

  static getNaptar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'naptar',
      args: { requestType: 'naptar-get' },
      params: {
        id
      }
    }], fnDone);
  }

  static editNaptar(naptar, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.naptarUrl + 'naptar',
      args: { requestType: 'naptar-put' },
      data: naptar
    }], fnDone);
  }

  static deleteNaptar(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.naptarUrl + 'naptar',
      args: { requestType: 'naptar-delete' },
      params: {
        id
      }
    }], fnDone);
  }

  static listIsmetlodesEnum(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'naptar/ismetlodesenum',
      args: { requestType: 'naptar-ismetlodesenum-get' },
    }], fnDone);
  }

  static listEsemenytipusByNaptartipus(naptartipusid, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.naptarUrl + 'esemenytipus/listbynaptartipus',
      args: { requestType: 'napesemenytipustar-listbynaptartipus-get' },
      params: { naptartipusid }
    }], fnDone);
  }

  // NAPTAR END

  // HELYSZIN START

  static listTerem(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'terem/listwithrolecheck',
      args: { requestType: 'terem-listwithrolecheck-get' }
    }], fnDone);
  }

  static getTeremByIds(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'terem/byids',
      args: { requestType: 'terem-byids-put' },
      data: ids
    }], fnDone);
  }

  static getHelyszinByIds(ids, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.helyszinUrl + 'helyszin/byids',
      args: { requestType: 'helyszin-byids-put' },
      data: ids
    }], fnDone);
  }

  static listPublicHelyszin(tipus, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/publiclist',
      args: { requestType: 'helyszin-publiclist-get' },
      params: { withImage: false, tipus }
    }], fnDone);
  }

  // HELYSZIN END

}
